/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {Fragment} from 'react';
import {FormLabel} from 'react-bootstrap';
import {Conditional} from '../../Conditional';
import {HelpIcon} from '../HelpIcon';
import {useGenericModelHooks, useShouldEditField} from "../../../Hooks/GenericModelHooks";

import {useFieldComponentRenderer} from "../../../Hooks/FieldComponentHooks";

export const StandardModelViewerRecordRenderer = props => {
    const {
        getFieldDefs,
    } = useGenericModelHooks(props);

    const shouldEditField = useShouldEditField();
    const editMode = shouldEditField(props);
    const fieldComponentRenderer = useFieldComponentRenderer(props);

    const {
        Data,
        EditMode,
        FieldDef: fieldDef,
        FieldDefinitionGroups = null,
        IsNewModel,
        OnValidationUpdate,
        RootData,
        SkipBorder,
        Validation,
        CustomData,
        DefaultSelectedFieldDefKey,
        tdClassName = '',
    //     defaultValue = undefined,
        subText = null,
    } = props;

    const fieldDefs = FieldDefinitionGroups ?? getFieldDefs?.(true);

    const fieldComponentName = editMode ? fieldDef.editor : fieldDef.viewer;
    const FieldComponent = fieldComponentRenderer(fieldComponentName, fieldDef, null, null, fieldDefs);

    if(FieldComponent == null) {
        return null;
    }

    return <Fragment>
        <tr className={"sb-editor-row-" + fieldDef?.key}>
            <Conditional Condition={fieldDef?.displayLabel}>
                <td className={"sb-model-viewer-column sb-model-viewer-column-label " + tdClassName}>
                    <FormLabel>
                        {fieldDef?.title}
                    </FormLabel>
                    <Conditional Condition={editMode && fieldDef?.helpText != ""}>
                        <HelpIcon id={"help-icon-" + fieldDef?.key}>{fieldDef?.helpText}</HelpIcon>
                    </Conditional>
                </td>
            </Conditional>
            <td className={"sb-model-viewer-column sb-model-viewer-column-value " + [tdClassName, Validation?.className].join(' ')}
                colSpan={fieldDef.displayLabel ? 1 : 2}
            >
                {FieldComponent}
                <Conditional Condition={subText != null}>
                        <span className="sb-sub-text">
                            Instead of: {subText}
                        </span>
                </Conditional>
                <div className="sb-model-viewer-validation-failure-text-small" id={Validation?.id}>
                    {Validation?.message ? Validation?.message : <span>&nbsp;</span>}
                </div>
            </td>
        </tr>
        <Conditional Condition={fieldDef?.displayLabel && SkipBorder}>
            <tr className="separator">
                <td>
                <hr/>
                </td>
                <td/>
            </tr>
        </Conditional>
    </Fragment>;
};
